import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=64462d56&scoped=true&"
import script from "./DropdownDivider.vue?vue&type=script&lang=js&"
export * from "./DropdownDivider.vue?vue&type=script&lang=js&"
import style0 from "./DropdownDivider.vue?vue&type=style&index=0&id=64462d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64462d56",
  null
  
)

export default component.exports